import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_CONFIG, NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { dagKeys } from '@/shared/lib/query/queryKeys';

import { triggerDagApi } from '@/entities/dag/api';
import type { TriggerDagRequest, TriggerDagResponse } from '@/entities/dag/domain/types';

export const useTriggerDagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<TriggerDagResponse, Error, TriggerDagRequest>({
    mutationFn: (request) => triggerDagApi(request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: dagKeys.all });

      notification.success({
        message: NOTIFICATION_MESSAGES.DAG_TRIGGER_SUCCESS,
        description: `${variables.dagUuid} - ${NOTIFICATION_MESSAGES.DAG_TRIGGER_SUCCESS_DESC}`,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.SUCCESS,
      });
    },
    onError: (error, variables) => {
      console.error('Failed to trigger DAG:', error);

      notification.error({
        message: NOTIFICATION_MESSAGES.DAG_TRIGGER_ERROR,
        description: `${variables.dagUuid} - ${NOTIFICATION_MESSAGES.DAG_TRIGGER_ERROR_DESC}`,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.ERROR,
      });
    },
  });
};
